import {
  AU_LITE_PRODUCT_ID,
  AU_PRO_PRODUCT_ID,
  AI_BAS_ADD_ON_IDS
} from '../../constants';
import { ValidProductsType } from './type';

class Rule {
  base: string;

  addOnIds: string[];

  constructor(base: string) {
    this.base = base;
    this.addOnIds = [];
  }

  allow(...addOns: string[]): Rule {
    this.addOnIds = addOns;
    return this;
  }
}

const rules: Rule[] = [
  new Rule(AU_LITE_PRODUCT_ID).allow(...AI_BAS_ADD_ON_IDS),
  new Rule(AU_PRO_PRODUCT_ID).allow(...AI_BAS_ADD_ON_IDS)
];

export const getValidProducts = (productId: string, addonIds?: string[]): ValidProductsType => {
  if (!addonIds || addonIds.length === 0) {
    return { productId, addonIds: undefined };
  }

  const rule = rules.find((r) => {
    return r.base === productId;
  });

  const validAddonIds = addonIds.filter((addOn) => {
    return rule ? rule.addOnIds.includes(addOn) : false;
  });

  return {
    productId,
    addonIds: validAddonIds.length > 0 ? validAddonIds : undefined
  };
};
